export default __webpack_public_path__ + "static/info-image-8c20c9b6c88833d0aeacc32382e998c5.png";